import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import AddHouse from './pages/AddHouse';
import EditHouse from './pages/EditHouse';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/add" element={<AddHouse />} />
          <Route path="/edit/:id" element={<EditHouse />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
